import type { SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";
import { signalTypeMap } from "app/pages/sales-intelligence/domain/signals/types/signal";
import type { SignalTypeKey } from "app/pages/sales-intelligence/domain/signals/types/signal-key";
import { toSignalTypeKey } from "app/pages/sales-intelligence/domain/signals/utils/signal-key";
import type { FilterSearchConfigMap } from "app/pages/sales-intelligence/modules/advanced-search-filtering/services/filter-search-service/types";
import advancedFilteringI18nKeys from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/i18n";

const GENERIC_SIGNAL_SEARCH_KEYWORDS: readonly string[] = [
    advancedFilteringI18nKeys.searchKeyword("alerts"),
    advancedFilteringI18nKeys.searchKeyword("notifications"),
    advancedFilteringI18nKeys.searchKeyword("events"),
];

const SIGNAL_TYPE_SEARCH_LITERALS: Partial<Record<SignalType, readonly string[]>> = {
    [signalTypeMap.adNetwork]: ["ad", "ads"],
    [signalTypeMap.technology]: ["tech"],
};

/**
 * Per-signal-type search config. Each split signal filter gets the generic discovery
 * terms plus any literals specific to that type, keeping types from matching one another.
 */
export const createSignalsFiltersSearchConfig = (): FilterSearchConfigMap<SignalTypeKey> =>
    Object.values(signalTypeMap).reduce<FilterSearchConfigMap<SignalTypeKey>>((acc, signalType) => {
        const literals = SIGNAL_TYPE_SEARCH_LITERALS[signalType];

        return {
            ...acc,
            [toSignalTypeKey(signalType)]: {
                keywords: {
                    translationKeys: GENERIC_SIGNAL_SEARCH_KEYWORDS,
                    ...(literals ? { literals } : {}),
                },
            },
        };
    }, {});
